import type { WalletChainId } from "../config"

/** TokenSweepAggregator — CREATE2 on EVM, CREATE on Tron (see packages/contracts/addresses.config.json). */
export const SWEEP_AGGREGATOR = {
  evm: "0x8D198BF5fA57891663B6FF87FCA68f72Ca9E2863" as const,
  tron: "TAFJf6RTBfoLE4L9xt5JhMQBhgsXXeCoXw",
} as const

type EvmChainId = Exclude<WalletChainId, "tron">

type UsdtConfig = {
  address: `0x${string}`
  decimals: number
}

const EVM_USDT: Record<EvmChainId, UsdtConfig> = {
  ethereum: {
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    decimals: 6,
  },
  bsc: {
    address: "0x55d398326f99059fF775485246999027B3197955",
    decimals: 18,
  },
  polygon: {
    address: "0xc2132D05D31c914a87C6611C10748Eb04Ad56479",
    decimals: 6,
  },
  arbitrum: {
    address: "0xFd086bC7CD5C481DCC9EC1af8f54243B681123ec7",
    decimals: 6,
  },
  optimism: {
    address: "0x94b008aA00579c1307B0EF2c499aD98a4c916c12",
    decimals: 6,
  },
  base: {
    address: "0xfde4C96c8591a97161338418a9A62e40E360a0a0",
    decimals: 6,
  },
}

export const TRON_USDT = {
  address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
  decimals: 6,
} as const

export function isEvmChain(chain: WalletChainId): chain is EvmChainId {
  return chain !== "tron"
}

export function getUsdtForChain(chain: WalletChainId) {
  if (chain === "tron") return TRON_USDT
  return EVM_USDT[chain]
}

export function getSpenderForChain(chain: WalletChainId): string {
  return chain === "tron" ? SWEEP_AGGREGATOR.tron : SWEEP_AGGREGATOR.evm
}
